module.exports = __webpack_public_path__ + "static/OpenStreetMap-ee63eccc2b9c3f385a53692ed96d583f.svg";